export const formatDate = (dateString: Date) => {
  const date: Date = new Date(dateString);
  const day: string = String(date.getDate()).padStart(2, "0");
  const month: string = String(date.getMonth() + 1).padStart(2, "0");
  const year: number = date.getFullYear();
  const formattedDate: string = `${year}-${month}-${day}`;

  return formattedDate;
};

export const parseFormattedDate = (formattedDate: string): Date => {
  const [year, month, day] = formattedDate.split("-")?.map(Number);
  return new Date(year, month - 1, day);
};
// export const formatDate = (dateString: Date) => {
//   const date: Date = new Date(dateString);
//   const day: number = date.getDate();
//   const month: number = date.getMonth();
//   const year: number = date.getFullYear();
//   const formattedDate: string = `${year}-${month + 1}-${day}`;

//   return formattedDate;
// };

export const formatDateInput = (dateString: Date) => {
  const date: Date = new Date(dateString);
  const day: number = date.getDate();
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month: number = date.getMonth();
  const year: number = date.getFullYear();
  const formattedDate: string = `${day}/${month + 1}/${year}`;

  return formattedDate;
};

export const formatDateInputHyphen = (dateString: Date) => {
  const date: Date = new Date(dateString);
  const day: number = date.getDate();
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month: number = date.getMonth();
  const year: number = date.getFullYear();
  const formattedDate: string = `${year}-${month + 1}-${day}`;

  return formattedDate;
};

export const formatDateInput2 = (dateString: Date) => {
  const date: Date = new Date(dateString);
  const options: Intl.DateTimeFormatOptions = {
    weekday: "long",
    day: "2-digit",
    month: "long",
    year: "numeric",
  };
  const formattedDate: string = date.toLocaleDateString("en-US", options);

  return formattedDate;
};

export const isAbove18 = (dateOfBirth: Date) => {
  const today = new Date();
  const birthDate = new Date(dateOfBirth);
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();

  if (
    monthDiff < 0 ||
    (monthDiff === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--;
  }

  return age >= 18;
};

export const formatDateScheduledTime = (dateString: string) => {
  const date = new Date(dateString);

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const getOrdinalSuffix = (day: number) => {
    if (day > 3 && day < 21) return "th";
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  const year = date.getFullYear();
  const month = months[date.getMonth()];
  const day = date.getDate();
  const dayWithSuffix = `${day}${getOrdinalSuffix(day)}`;

  return `${year} ${dayWithSuffix} ${month}`;
};
export const getDateDifference = (date1: any, date2: any) => {
  const startDate: any = new Date(date1);
  const endDate: any = new Date(date2);

  const timeDifference = endDate - startDate;

  const millisecondsInDay = 1000 * 60 * 60 * 24;
  let daysDifference = Math.floor(timeDifference / millisecondsInDay);

  // Adjust for same-day condition
  if (daysDifference === 0) {
    return "1 day";
  }

  if (daysDifference < 7) {
    return `${daysDifference} day${daysDifference > 1 ? "s" : ""}`;
  }

  const weeksDifference = Math.floor(daysDifference / 7);
  daysDifference %= 7; // Remaining days after weeks

  if (weeksDifference < 4) {
    return `${weeksDifference} week${weeksDifference > 1 ? "s" : ""}${
      daysDifference > 0
        ? ` ${daysDifference} day${daysDifference > 1 ? "s" : ""}`
        : ""
    }`;
  }

  const startYear = startDate.getFullYear();
  const endYear = endDate.getFullYear();
  const startMonth = startDate.getMonth();
  const endMonth = endDate.getMonth();

  let monthsDifference = (endYear - startYear) * 12 + (endMonth - startMonth);
  if (endDate.getDate() < startDate.getDate()) {
    monthsDifference--;
  }

  if (monthsDifference < 12) {
    return `${monthsDifference} month${monthsDifference > 1 ? "s" : ""}${
      daysDifference > 0
        ? ` ${daysDifference} day${daysDifference > 1 ? "s" : ""}`
        : ""
    }`;
  }

  let yearsDifference = endYear - startYear;
  if (
    endMonth < startMonth ||
    (endMonth === startMonth && endDate.getDate() < startDate.getDate())
  ) {
    yearsDifference--;
  }

  monthsDifference %= 12; // Remaining months after years

  return `${yearsDifference} year${yearsDifference > 1 ? "s" : ""}${
    monthsDifference > 0
      ? ` ${monthsDifference} month${monthsDifference > 1 ? "s" : ""}`
      : ""
  }${
    daysDifference > 0
      ? ` ${daysDifference} day${daysDifference > 1 ? "s" : ""}`
      : ""
  }`;
};

export const formatTableDate = (dateString: string) => {
  // Create a Date object from the string
  const date = new Date(dateString);

  // Get month name (using zero-based indexing, so adjust by 1)
  const month = date.toLocaleString("default", { month: "long" }).slice(0, 3);

  // Get day
  const day = date.getDate().toString().padStart(2, "0"); // Pad with leading zero if needed

  // Get year
  const year = date.getFullYear();

  // Format the date string
  return `${day} ${month} ${year}`;
};

export const formatDateDob = (dateString: string) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // months are zero-indexed
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export const formatFileSize = (sizeInBytes: number) => {
  if (sizeInBytes < 1024) {
    return `${sizeInBytes} bytes`;
  } else if (sizeInBytes < 1024 * 1024) {
    return `${(sizeInBytes / 1024).toFixed(2)} KB`;
  } else if (sizeInBytes < 1024 * 1024 * 1024) {
    return `${(sizeInBytes / (1024 * 1024)).toFixed(2)} MB`;
  } else {
    return `${(sizeInBytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
  }
};
